/* ============================================================
   PLUSHIE PATCH — product page interactions
   Reads window.PP_VARIANTS (real Shopify variant data).
   ============================================================ */
(function () {
  "use strict";
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var variants = window.PP_VARIANTS || [];
    var selected = {}; // optionIndex -> value

    /* ----- money formatting ----- */
    function formatMoney(cents) {
      var fmt = window.PP_MONEY_FORMAT || "${{amount}}";
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount)
               .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }

    /* ----- gallery ----- */
    window.ppSetImg = function (btn, src) {
      var main = document.getElementById('mainImg');
      if (main) main.src = src;
      document.querySelectorAll('.thumbs button').forEach(function (b) { b.classList.remove('on'); });
      if (btn) btn.classList.add('on');
    };
    // image zoom toggle (desktop fun)
    var wrap = document.getElementById('mainImgWrap');
    if (wrap) wrap.addEventListener('click', function () {
      if (window.matchMedia('(hover:hover)').matches) wrap.classList.toggle('zoom');
    });

    /* ----- read initial selected options from rendered "on" chips ----- */
    document.querySelectorAll('.sizes[data-option-index]').forEach(function (row) {
      var idx = parseInt(row.getAttribute('data-option-index'), 10);
      var on = row.querySelector('.size.on');
      if (on) selected[idx] = on.getAttribute('data-value');
    });

    /* ----- find a variant matching current selection ----- */
    function matchVariant() {
      var optCount = document.querySelectorAll('.sizes[data-option-index]').length;
      if (optCount === 0) return variants[0]; // default-variant product
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var idx in selected) {
          if (v.options[idx] !== selected[idx]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    /* ----- update UI for the matched variant ----- */
    function updateVariant() {
      var v = matchVariant();
      var addBtn = document.getElementById('ppAddBtn');
      var vidField = document.getElementById('ppVariantId');
      var priceEl = document.getElementById('price');
      var cmpEl = document.getElementById('compare');
      var offEl = document.getElementById('offPct');
      var stickyP = document.getElementById('stickyPrice');
      var saveBadge = document.getElementById('saveBadge');
      var stockBadge = document.getElementById('stockBadge');

      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (vidField) vidField.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (stickyP) stickyP.textContent = formatMoney(v.price);

      // compare-at + discount
      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      if (cmpEl) {
        if (hasCompare) { cmpEl.style.display = ''; cmpEl.textContent = formatMoney(v.compare_at_price); }
        else cmpEl.style.display = 'none';
      }
      if (offEl) {
        if (hasCompare) { offEl.style.display = ''; offEl.textContent = '-' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'; }
        else offEl.style.display = 'none';
      }
      if (saveBadge) {
        if (hasCompare) { saveBadge.style.display = ''; saveBadge.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'; }
        else saveBadge.style.display = 'none';
      }

      // availability
      if (addBtn) {
        if (v.available) { addBtn.disabled = false; addBtn.textContent = 'Add to cart 🧸'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
      }

      // low-stock badge (live update)
      if (stockBadge) {
        var low = window.PP_LOW_STOCK || 8;
        if (v.available && typeof v.inventory_quantity === 'number' && v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= low) {
          stockBadge.style.display = '';
          stockBadge.innerHTML = '<span class="pulse"></span>Only ' + v.inventory_quantity + ' left — almost gone!';
        } else {
          stockBadge.style.display = 'none';
        }
      }

      // swap main image to the variant's image, if it has one
      if (v.featured_image && v.featured_image.src) {
        var main = document.getElementById('mainImg');
        if (main) {
          var src = v.featured_image.src;
          main.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900';
        }
      }
    }

    /* ----- option selection ----- */
    window.ppPickOption = function (optIndex, el) {
      var row = el.closest('.sizes');
      row.querySelectorAll('.size').forEach(function (s) { s.classList.remove('on'); });
      el.classList.add('on');
      selected[optIndex] = el.getAttribute('data-value');
      // update the "picked" label
      var lbl = document.querySelector('.picked[data-picked="' + optIndex + '"]');
      if (lbl) lbl.textContent = el.getAttribute('data-value');
      updateVariant();
    };

    /* ----- quantity ----- */
    var qty = 1;
    window.ppQty = function (d) {
      qty = Math.max(1, qty + d);
      document.getElementById('qty').textContent = qty;
      var qi = document.getElementById('ppQtyInput'); if (qi) qi.value = qty;
    };

    /* ----- add to cart (AJAX) with hearts burst ----- */
    var form = document.getElementById('ppProductForm');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var addBtn = document.getElementById('ppAddBtn');
        if (addBtn && addBtn.disabled) return;
        var data = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: data })
          .then(function (r) { return r.json(); })
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
            heartsBurst(addBtn);
            toast('Added to your cuddle cart 🧸');
          })
          .catch(function () { toast('Hmm — please try again'); });
      });
    }

    function heartsBurst(anchor) {
      var rect = (anchor || document.body).getBoundingClientRect();
      var emojis = ['💖', '🧸', '✨', '💕', '🌟'];
      for (var i = 0; i < 6; i++) {
        var h = document.createElement('div');
        h.className = 'heart-burst';
        h.textContent = emojis[i % emojis.length];
        h.style.left = (rect.left + rect.width / 2 + (Math.random() * 60 - 30)) + 'px';
        h.style.top = (rect.top + window.scrollY - 10) + 'px';
        document.body.appendChild(h);
        setTimeout((function (el) { return function () { el.remove(); }; })(h), 1000);
      }
    }

    /* ----- size helper ----- */
    window.ppToggleSize = function () {
      var p = document.getElementById('sizePop');
      if (p) p.classList.toggle('show');
    };

    /* ----- estimated delivery (location-based, calculated live) ----- */
    // [minDays, maxDays] = processing (1–3) + tracked shipping, by region. Tuned to
    // real AliExpress-fulfilled transit times (most parcels land within ~2 weeks).
    // Country → shipping zone, and zone → [min,max] calendar days.
    // Calibrated to 2026 AliExpress Standard/Selection transit + 1–3 day processing.
    var COUNTRY_ZONE = {AL:"EU_EAST", DZ:"AFRICA", AD:"EU_WEST", AI:"LATAM", AR:"LATAM", AM:"ASIA_OTHER", AU:"OCEANIA", AT:"EU_WEST", BY:"EU_EAST", BE:"EU_WEST", BR:"LATAM", CM:"AFRICA", CA:"NA_CA", CV:"AFRICA", BQ:"LATAM", KY:"LATAM", CF:"AFRICA", CL:"LATAM", CO:"LATAM", CD:"AFRICA", CK:"OCEANIA", CR:"LATAM", CI:"AFRICA", HR:"EU_EAST", CY:"EU_EAST", CZ:"EU_EAST", DK:"EU_NORDIC", DJ:"AFRICA", DM:"LATAM", DO:"LATAM", EC:"LATAM", EG:"MENA", SV:"LATAM", GQ:"AFRICA", ER:"AFRICA", EE:"EU_EAST", SZ:"AFRICA", ET:"AFRICA", FK:"LATAM", FO:"EU_NORDIC", FJ:"OCEANIA", FI:"EU_NORDIC", FR:"EU_WEST", GF:"LATAM", PF:"OCEANIA", TF:"OTHER", GA:"AFRICA", GM:"AFRICA", GE:"ASIA_OTHER", DE:"EU_WEST", GH:"AFRICA", GI:"EU_WEST", GR:"EU_EAST", GL:"EU_NORDIC", GN:"AFRICA", GW:"AFRICA", GY:"LATAM", HT:"LATAM", HN:"LATAM", HK:"ASIA_FAST", HU:"EU_EAST", IS:"EU_NORDIC", ID:"ASIA_FAST", IQ:"MENA", IE:"UK_IE", IT:"EU_WEST", JM:"LATAM", JP:"ASIA_FAST", KZ:"ASIA_OTHER", XK:"EU_EAST", LV:"EU_EAST", LI:"EU_WEST", LT:"EU_EAST", LU:"EU_WEST", MY:"ASIA_FAST", MV:"ASIA_OTHER", MT:"EU_EAST", MX:"NA_MX", MD:"EU_EAST", MC:"EU_WEST", MA:"MENA", NL:"EU_WEST", NZ:"OCEANIA", NG:"AFRICA", MK:"EU_EAST", NO:"EU_NORDIC", PA:"LATAM", PY:"LATAM", PE:"LATAM", PH:"ASIA_FAST", PL:"EU_EAST", PT:"EU_WEST", QA:"MENA", RO:"EU_EAST", RU:"RUSSIA", SM:"EU_WEST", SA:"MENA", SN:"AFRICA", RS:"EU_EAST", SG:"ASIA_FAST", SK:"EU_EAST", SI:"EU_EAST", ZA:"AFRICA", KR:"ASIA_FAST", ES:"EU_WEST", SE:"EU_NORDIC", CH:"EU_WEST", TH:"ASIA_FAST", TN:"MENA", TR:"MENA", UM:"NA_US", UA:"EU_EAST", AE:"MENA", GB:"UK_IE", US:"NA_US", UY:"LATAM", UZ:"ASIA_OTHER", VA:"EU_WEST", VE:"LATAM", VN:"ASIA_FAST"};
    var ZONE_DAYS = {NA_US:[7,15], NA_CA:[9,18], NA_MX:[11,24], UK_IE:[9,19], EU_WEST:[9,20], EU_NORDIC:[10,22], EU_EAST:[10,23], OCEANIA:[12,25], ASIA_FAST:[8,18], ASIA_OTHER:[12,26], MENA:[11,24], LATAM:[13,28], AFRICA:[14,32], RUSSIA:[14,30], OTHER:[12,30]};

    function fmtDate(d) {
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }

    window.ppUpdateETA = function () {
      var sel = document.getElementById('ppCountry');
      var rangeEl = document.getElementById('etaRange');
      var confEl = document.getElementById('etaConf');
      var barEl = document.getElementById('etaBar');
      if (!sel || !rangeEl) return;
      var code = sel.value;
      var zone = COUNTRY_ZONE[code] || 'OTHER';
      var win = ZONE_DAYS[zone] || ZONE_DAYS.OTHER;
      var now = new Date();
      var d1 = new Date(now.getTime()); d1.setDate(d1.getDate() + win[0]);
      var d2 = new Date(now.getTime()); d2.setDate(d2.getDate() + win[1]);
      rangeEl.textContent = fmtDate(d1) + ' – ' + fmtDate(d2);
      // confidence note + progress bar (faster = fuller/greener bar)
      var mid = (win[0] + win[1]) / 2;
      if (confEl) {
        confEl.textContent = mid <= 15
          ? '📦 Most orders to this region arrive within about 2 weeks.'
          : '📦 International orders here typically arrive within 2–3 weeks.';
      }
      if (barEl) {
        // 8 days → ~85% full, 25 days → ~30% full
        var pct = Math.max(25, Math.min(90, Math.round(100 - (mid - 8) * 4)));
        barEl.style.width = pct + '%';
      }
    };

    // auto-select the visitor's country (from Shopify localization), then calculate
    (function initETA() {
      var sel = document.getElementById('ppCountry');
      if (!sel) return;
      var code = (window.PP_COUNTRY || '').toUpperCase();
      var has = false;
      for (var i = 0; i < sel.options.length; i++) { if (sel.options[i].value === code) { has = true; break; } }
      sel.value = has ? code : 'OTHER';
      window.ppUpdateETA();
    })();

    function toast(m) {
      var t = document.getElementById('toast');
      if (!t) { t = document.createElement('div'); t.className = 'toast'; t.id = 'toast'; document.body.appendChild(t); }
      t.textContent = m; t.classList.add('show');
      clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('show'); }, 2400);
    }
    window.toast = toast;

    /* ----- async related products (Shopify recommendations) ----- */
    var rec = document.getElementById('ppRecommendations');
    if (rec && rec.dataset.url && rec.children.length === 0) {
      fetch(rec.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var div = document.createElement('div');
          div.innerHTML = html.trim();
          var inner = div.querySelector('#ppRecommendations');
          if (inner) rec.innerHTML = inner.innerHTML;
        })
        .catch(function () {});
    }

    updateVariant();
  }
})();
